<header class="perfil-progress-general">
  <h2 class="perfil-progress-general__title">{{ titulo }}</h2>
  <div class="perfil-progress-general__meta">
    <span>{{ progresoClamped | number: '1.0-0' }}% {{ copy.hub.completadoSuffix }}</span>
    <span class="perfil-progress-general__dot" aria-hidden="true"></span>
    <span>{{ seccionesCompletas }}/{{ totalSecciones }} {{ copy.hub.seccionesSuffix }}</span>
  </div>
</header>
